import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import getBorderRadius from "../utils/getBorderRadius";
import { isFunc, isNumber } from "../utils/type";
export var controlStyle = function controlStyle(_, props) {
  var borderRadius = props.selectProps.borderRadius;

  if (typeof borderRadius !== 'undefined') {
    return _objectSpread({}, getBorderRadius(borderRadius));
  }

  return {};
};
export var menuListStyle = function menuListStyle(provided, props) {
  var _props$selectProps = props.selectProps,
      isMobile = _props$selectProps.isMobile,
      isGroup = _props$selectProps.isGroup,
      autoMobileMenuHeight = _props$selectProps.autoMobileMenuHeight;
  var maxHeight = provided.maxHeight;

  if (isGroup && isNumber(maxHeight)) {
    maxHeight += isMobile ? 57 : 44;
  }

  return _objectSpread(_objectSpread({}, provided), {}, {
    maxHeight: autoMobileMenuHeight && isMobile ? 'auto' : maxHeight,
    padding: 0
  });
};
export var inputStyle = function inputStyle(provided) {
  return _objectSpread(_objectSpread({}, provided), {}, {
    flexShrink: 0,
    margin: '15px 0px 0px'
  });
};
export var noOptionsMessageStyle = function noOptionsMessageStyle(provided) {
  return _objectSpread(_objectSpread({}, provided), {}, {
    color: 'inherit'
  });
};
export var menuPortalStyle = function menuPortalStyle(provided) {
  return _objectSpread(_objectSpread({}, provided), {}, {
    zIndex: 999
  });
};
export function checkWhetherFuncReturnNull(fn) {
  return isFunc(fn) && fn() == null;
}